// extracted by mini-css-extract-plugin
module.exports = {"container":"product-boxes-module--container--3wD_M"};